module.exports = flarum.core.compat['forum/components/ChatRoom'];